<script>
  export let showCart = false
  export let cartItemsList = []
</script>


{#if showCart}
  <div class="absolute z-30 top-0 right-0 bg-white shadow-lg text-left p-10 text-black"
       style="min-width: 60em;"
       on:click={() => { showCart = false }}
  >
    <div class="text-xl text-black">Cart</div>
    {#each cartItemsList as r}
      <div class="py-3 flex border-b border-gray-400">
        <div class="w-40">{r.sparePart.SparePartNo}</div>
        <div class="w-40">{r.sparePart.quantity}</div>
        <div class="w-56">{r.key}</div>
      </div>
    {/each}
  </div>
{/if}
